import { Color, ColorAbr } from 'services/apiTypes/card.types'
import { CardType } from 'types/deck'

export const ALL_COLORS = ['White', 'Blue', 'Black', 'Red', 'Green'] as Color[]
export const ALL_COLOR_ABRS = ['W', 'U', 'B', 'R', 'G'] as ColorAbr[]

export function getCardsColorIdenty(colors: Color[], card: CardType) {
  colors.push(...card.colorIdentity)

  return [...new Set(colors)]
}
